export const AddToCart = "AddToCart";
export const RemoveFromCart = "RemovefromCart";
export const PlusFromCart = "PlusfromCart";
export const MinusFromCart = "MinusfromCart";
